import type { FAQItem } from "@/components/FAQStructuredData";

/**
 * 这个页面 FAQ 的唯一真实来源,server(生成 FAQPage JSON-LD)与 client(渲染
 * 可见区块)共用。数据若定义在带 "use client" 的组件里再导出,server 侧拿到的是
 * client reference,一 map() 就报 "Attempted to call map() from the server"。
 *
 * ## 前四条不是猜的
 *
 * 它们是 DataForSEO 在 `relationship fortune cookie`(720/月,本簇最大词)的
 * SERP 里实际返回的 People Also Ask 问题,一字未改:
 *
 *   - What does a fortune cookie say about relationships?
 *   - Will you be my girlfriend fortune cookie?
 *   - What are some romantic fortune sayings?
 *   - What are good fortunes to put in a fortune cookie?
 *
 * 这一点和 /funny-fortune-cookie-messages 那条起源问句不同 —— 那条是押注
 * (当时抓不到 PAA,注释里写明了)。这四条是实测。
 */
export const faqData: FAQItem[] = [
  {
    question: "What does a fortune cookie say about relationships?",
    answer:
      "The good ones say something you already suspected but had not put into words — that listening beats agreeing, that the argument is rarely about the dishes, that you cannot love somebody into changing. The Relationships section on this page collects twelve of them, written to be read out loud rather than skimmed.",
  },
  {
    question: "Will you be my girlfriend fortune cookie — how do I make one?",
    answer:
      "Write the question on a strip of paper about 8cm by 1cm, then either bake it into a homemade cookie while the wafer is still warm and foldable, or slide it into a shop-bought one by hand. The Will You Be Mine section has twelve versions to copy, from the direct to the deliberately ridiculous.",
  },
  {
    question: "What are some romantic fortune sayings?",
    answer:
      "Romantic fortune sayings work best when they are specific rather than sweeping. Love is not one grand gesture, it is ten thousand small ones nobody sees. Keep dating the person you already have. Comfortable is not the opposite of romantic, it is the reward for it. There are 120 on this page across ten themes.",
  },
  {
    question: "What are good fortunes to put in a fortune cookie?",
    answer:
      "Short ones. Anything under about twelve words fits on a real paper slip without folding twice. Match the fortune to the occasion — wedding favours read differently from a first-date note — and write as though one particular person will open it, because one will.",
  },
  {
    question: "Can I use these for wedding favours?",
    answer:
      "Yes. The Weddings section is written for exactly that: one line per place setting, different at every seat, short enough to read aloud between courses. They are free to print and use.",
  },
  {
    question: "Where can I get a love fortune cookie right now?",
    answer:
      "Tap the cookie on our homepage for an instant one, or open the Generator to have the AI write a romantic fortune to your own brief — a name, an occasion, a tone. This page is the ready-made collection; the Generator is for when you want something nobody else has read.",
  },
];
